import { useAppContext } from '../context/AppContext';
import { useAuth } from '../context/AuthContext';
import { DEFAULT_SUBSCRIPTION } from '../services/SubscriptionService';
import { DEFAULT_SUBSCRIPTION_LIMITS, SubscriptionLimits, SubscriptionPlan } from '../types/subscription';

export const useSubscription = () => {
    const { db } = useAppContext();
    const { userData } = useAuth();

    const userSubscription = userData?.subscription || DEFAULT_SUBSCRIPTION;
    const plan = userSubscription.plan as SubscriptionPlan;

    // Get limits from Global Config (Firestore) OR fallback to code defaults
    const getLimits = (): SubscriptionLimits => {
        const defaultLimits = DEFAULT_SUBSCRIPTION_LIMITS[plan] || DEFAULT_SUBSCRIPTION_LIMITS['starter'];
        if (db.globalConfig?.subscriptionLimits && db.globalConfig.subscriptionLimits[plan]) {
            return { ...defaultLimits, ...db.globalConfig.subscriptionLimits[plan] };
        }
        return defaultLimits;
    };

    const limits = getLimits();

    return {
        subscription: userSubscription,
        plan,
        limits,
        check: {
            canCreateGroup: (currentCount: number) => {
                if (currentCount >= limits.maxGroups) {
                    return { allowed: false, reason: `Votre offre ${plan.toUpperCase()} est limitée à ${limits.maxGroups} groupe(s).` };
                }
                return { allowed: true };
            },
            canAddPlayerToGroup: (currentGroupSize: number) => {
                if (currentGroupSize >= limits.maxPlayersPerGroup) {
                    return { allowed: false, reason: `Votre offre ${plan.toUpperCase()} est limitée à ${limits.maxPlayersPerGroup} joueurs par groupe.` };
                }
                return { allowed: true };
            },
            canCreateTournament: () => {
                if (!limits.canCreateTournaments) {
                    return { allowed: false, reason: "L'offre STARTER ne permet pas de créer des tournois." };
                }
                return { allowed: true };
            },
            canManageSponsors: () => {
                const max = limits.maxSponsors || 0;
                if (max === 0) {
                    return { allowed: false, reason: "Gestion des sponsors réservée aux abonnements Premium/Pro.", max: 0 };
                }
                return { allowed: true, max };
            },
            canAccessKiosk: () => {
                if (!limits.canAccessKioskMode) {
                    return { allowed: false, reason: "Le mode TV (Kiosque) est réservé aux abonnements Club/Pro." };
                }
                return { allowed: true };
            }
        }
    };
};
